import PropTypes from "prop-types";

export const TableRow = ({ children }) => <tr className="">{children}</tr>;

TableRow.propTypes = {
  children: PropTypes.node.isRequired,
};
